// import { Pagination, Stack, ThemeProvider, createTheme } from "@mui/material";
// import React, { useEffect, useState } from "react";

// const PaginationComponent = ({
//   setPaginatedData,
//   filteredData,
// }) => {
//   // console.log(data, 'data')
//   const itemsPerPage = 5;
//   const [currentPage, setCurrentPage] = useState(1);
//   const handlePageChange = (event, newPage) => {
//     setCurrentPage(newPage);
//   };


//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex));
//   }, [currentPage, filteredData]);

//   const theme = createTheme({
//     palette: { primary: { main: "#E5E7EB", contrastText: "#00000" } },
//   });

//   return (
//     <div>
//       <ThemeProvider theme={theme}>
//         <Stack direction="row" justifyContent="center" marginTop={2}>
//           <Pagination
//             count={Math.ceil(filteredData?.length / itemsPerPage)}
//             page={currentPage}
//             onChange={handlePageChange}
//             color="primary"
//           />
//         </Stack>
//       </ThemeProvider>
//     </div>
//   );
// };

// export default PaginationComponent;

import { Pagination, Stack, ThemeProvider, createTheme } from "@mui/material";
import React, { useEffect } from "react";

const theme = createTheme({
  palette: { primary: { main: "#374151", contrastText: "#ffffff" } },
});

const PaginationComponent = ({
  setPaginatedData,
  filteredData,
  currentPage,
  setCurrentPage,
  itemsPerPage = 10,
}) => {
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) ?? []);
  }, [currentPage, filteredData]);

  const totalPages = Math.ceil((filteredData?.length ?? 0) / itemsPerPage);

  return (
    <ThemeProvider theme={theme}>
      <Stack direction="row" justifyContent="center" marginTop={2}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="[#B0B0B0]"
          shape="rounded"
        />
      </Stack>
    </ThemeProvider>
  );
};

export default PaginationComponent;